import http from './http'

export function loginApi(username, password, systemId) {
  return http.post('/auth/login', { username, password, systemId: systemId ?? null })
}

export function fetchMeApi() {
  return http.get('/user/me')
}

export function fetchSystemOptionsApi() {
  return http.get('/systems/options')
}

export function fetchSelectableSystemsApi(username) {
  return http.get('/systems/selectable', { params: { username } })
}
